import { caseTopic } from './caseTopics';
import { paragraph } from './paragraph';

export const fragments = {
	caseTopic,
	paragraph,
};
